import styled from 'styled-components';
import { layout } from 'src/components/base';

export const SiteWidthWrapper = styled.div`
  max-width: ${layout.siteWidth.rem};
`;
